import { selectCurrentHotelId } from 'accessors'
import { OccupancyCell } from 'features/Occupancy'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import internalOnlyApi from 'services/api/internalOnly'

import styles from './OccupancyBar.module.scss'

const OccupancyBar = () => {
  const [data, setData] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)

  const subsidiaryId = useSelector(selectCurrentHotelId)

  useEffect(() => {
    internalOnlyApi
      .occupancy({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().add(30, 'days').format('YYYY-MM-DD'),
        subsidiaryId
      })
      .then(res => {
        setData(res)

        setIsLoading(false)
      })
      .catch(() => {
        setIsErred(true)
        setIsLoading(false)
      })
  }, [subsidiaryId])

  if (isLoading) return null

  if (isErred) return null

  if (!data.length) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.titleRow}>
          <div className={styles.titleRowDays}>
            {data[0].occupancyByDays.map((day, index) => {
              return (
                <div key={index}>
                  <div
                    className={
                      [0, 6].includes(moment(day.date).day())
                        ? styles.occupancyDateWeekend
                        : styles.occupancyDate
                    }
                  >
                    {moment(day.date).format('D')}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={styles.row}>
          {data[0].occupancyByDays.map(day => {
            return (
              <OccupancyCell
                height={22}
                value={day.occupancy}
                date={day.date}
                emptyRooms={day.emptyRooms}
                key={day.date}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default OccupancyBar
